module.exports = {
    BASE_URL: 'https://cms.climaxholdingsltd.com/api/',
    // BASE_URL: 'https://project.bestinbd.com/projects/web/2306CML/dev/api/',
    MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}
